import React from "react";
import Marquee from "react-fast-marquee";
import { useT } from "../../i18n";

export default function EditorialMarquee() {
  const { t } = useT();
  const items = t("marquee.items") || [];
  return (
    <section
      className="border-y border-[#1a211c]/10 py-6 md:py-8 bg-[#efece4]"
      data-testid="marquee-section"
      aria-hidden="false"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {items.concat(items).map((it, i) => (
          <span
            key={i}
            className="marquee-item font-serif text-[1.6rem] md:text-[2.2rem] text-[#1a211c]"
          >
            {it}
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#c5b293]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
